/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types,jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import {
  selectRequestState,
  sendFrom,
  requestRecoveryForm
} from 'mt-react-common/modules/messenger/reducers/static/forms/createGroupRoom/createGroupRoomForm';

import OpacityPreLoader from 'components/Common/PreLoaders/OpacityPreLoader';

import PublicSearchUserBlock from './PublicSearchUserBlock';
import CreatePrivateRoomBlock from './CreatePrivateRoomBlock';

const messengerModuleRN = 'messengerModule.forms.createRoomForm';

class MessengerGroupRoomFormPopUp extends Component {
  componentDidMount() {
    if (this.props.roomUuid) {
      this.props.requestRecoveryForm(this.props.roomUuid);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.requestState.hasSuccessQuery !==
        this.props.requestState.hasSuccessQuery &&
      this.props.requestState.hasSuccessQuery
    ) {
      this.props.handleClose();
    }
  }
  render() {
    return (
      <div
        className="modal-dialog"
        role="document"
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header text-center">
            <a
              href=""
              className="close close-black"
              onClick={this.props.handleClose}
            />
            <h2 className="modal-title h4">{t('Создать диалог')}</h2>
          </div>
          {this.props.requestState.hasInProgress ? <OpacityPreLoader /> : null}
          <div>
            <div className="modal-body">
              <CreatePrivateRoomBlock />
            </div>
            <div
              className="modal-custom"
              style={{
                backgroundColor: '#fff',
                borderTop: '2px solid #ddd'
              }}
            >
              <PublicSearchUserBlock />
            </div>
            <div className="modal-footer">
              {this.props.roomUuid ? (
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => {
                    this.props.sendFrom(this.props.roomUuid);
                  }}
                >
                  {t('Применить изменения')}
                </button>
              ) : (
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => {
                    this.props.sendFrom();
                  }}
                >
                  {t('Создать беседу')}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MessengerGroupRoomFormPopUp.defaultProps = {
  roomUuid: null
};

MessengerGroupRoomFormPopUp.propTypes = {
  // IN
  handleClose: PropTypes.func.isRequired,
  roomUuid: PropTypes.string,

  // CONNECT
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  sendFrom: PropTypes.func.isRequired,
  requestRecoveryForm: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, messengerModuleRN)
});

const mapDispatchToProps = dispatch => ({
  sendFrom: value => dispatch(sendFrom(messengerModuleRN, value)),
  requestRecoveryForm: rootUuid =>
    dispatch(requestRecoveryForm(messengerModuleRN, rootUuid))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MessengerGroupRoomFormPopUp);



// WEBPACK FOOTER //
// ./src/components/Messenger/content/MessengerGroupRoomFormPopUp/MessengerGroupRoomFormPopUp.js